var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCloseSquare = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66976 -0.000976562H14.3398C17.7298 -0.000976562 19.9998 2.37902 19.9998 5.91902V14.09C19.9998 17.62 17.7298 19.999 14.3398 19.999H5.66976C2.27976 19.999 -0.000244141 17.62 -0.000244141 14.09V5.91902C-0.000244141 2.37902 2.27976 -0.000976562 5.66976 -0.000976562ZM13.0098 12.999C13.3498 12.66 13.3498 12.11 13.0098 11.77L11.2298 9.99002L13.0098 8.20902C13.3498 7.87002 13.3498 7.31002 13.0098 6.97002C12.6698 6.62902 12.1198 6.62902 11.7698 6.97002L9.99976 8.74902L8.21976 6.97002C7.86976 6.62902 7.31976 6.62902 6.97976 6.97002C6.63976 7.31002 6.63976 7.87002 6.97976 8.20902L8.75976 9.99002L6.97976 11.76C6.63976 12.11 6.63976 12.66 6.97976 12.999C7.14976 13.169 7.37976 13.26 7.59976 13.26C7.82976 13.26 8.04976 13.169 8.21976 12.999L9.99976 11.23L11.7798 12.999C11.9498 13.18 12.1698 13.26 12.3898 13.26C12.6198 13.26 12.8398 13.169 13.0098 12.999Z",
    fill: "#B0B0B0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/closeSquare.d66580a9.svg";
export { ForwardRef as ReactComponent };